import { useTranslations } from 'next-intl'
import Image from 'next/image'

import { TServiceType } from '../types'
import { AvailabilityIcons } from './availability-icons'

interface IProvidersTableProps {
  type: TServiceType
}

export function ProvidersTable({ type }: IProvidersTableProps) {
  const t = useTranslations('Services')

  return (
    <div>
      <table className="w-full">
        <thead className="h-8">
          <tr className="mb-6 border-b border-gray-100">
            <th className="text-primary-600 text-body-3 py-4 pr-4 text-left">
              {t(
                type.providerColumnTitle ?? 'categories.serviceProvider.title'
              )}
            </th>
            <th className="text-primary-600 text-body-3 py-4 pr-4 text-left">
              {t('categories.commission.title')}
            </th>
            <th className="text-primary-600 text-body-3 py-4 pr-4 text-left">
              {t('categories.maxSum.title')}
            </th>
            <th className="text-primary-600 text-body-3 py-4 pr-4 text-left">
              {t('categories.transferPeriod.title')}
            </th>
            <th className="text-primary-600 text-body-3 py-4 pr-4 text-left">
              {t('categories.available.title')}
            </th>
          </tr>
        </thead>
        <tbody>
          {type.providers.map((provider) => (
            <tr
              key={`${type.name}-${provider.name}`}
              className="border-gray-100 not-last:border-b"
            >
              <td className="w-[25%] py-4">
                <div className="flex items-center gap-4 px-2">
                  {provider.img && (
                    <Image
                      src={provider.img}
                      alt={`${t(provider.name)} logo`}
                      width={40}
                      height={40}
                    />
                  )}
                  <span className="text-body-3 text-primary-400">
                    {t(provider.name)}
                  </span>
                </div>
              </td>
              <td className="py-4">
                <span className="text-primary-400 inline-block max-w-55">
                  {provider.commission.map((commission) => (
                    <span key={commission}>{t(commission)}</span>
                  ))}
                </span>
              </td>
              <td className="py-4">
                <span className="text-primary-400">
                  {provider.maxSum
                    ? `${provider.maxSum}֏${provider.maxSumNote ?? ''}`
                    : ''}
                </span>
              </td>
              <td className="py-4">
                <span className="text-primary-400">{t(provider.period)}</span>
              </td>
              <td className="py-4">
                <div className="flex items-center justify-center gap-1">
                  <AvailabilityIcons available={provider.available} size="md" />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
